import { useState } from 'react';
import ModalComponent from 'components/Common/Modal';
import useUploadFiles from 'api/hooks/useUploadFiles';
import createNotification from 'components/Settings/Utilities/CreateNotification';
import { UploadHubListItem } from 'api/services/uploadFileService';
import UploadHubFileDropzone from 'components/UploadHub/UploadHubFileDropzone';

interface UploadHubModalAddProps {
  openState: {
    isOpen: boolean;
    setIsOpen: (value: boolean) => void;
  };
  filesState: {
    listFiles: Array<UploadHubListItem>;
    setListFiles: (value: Array<UploadHubListItem>) => void;
  };
}

const UploadHubModalAdd = (props: UploadHubModalAddProps) => {
  const { openState, filesState } = props ?? {};
  const { listFiles, setListFiles } = filesState ?? {};
  const { isOpen, setIsOpen } = openState ?? {};
  const { uploadPendingFiles } = useUploadFiles();

  const [pendingFiles, setPendingFiles] = useState<File[]>([]);
  const [isUploading, setIsUploading] = useState(false);

  const handleUpload = async () => {
    if (pendingFiles.length === 0) return;
    setIsUploading(true);
    try {
      const createdItems: UploadHubListItem[] = await uploadPendingFiles(pendingFiles);
      createNotification('success', 'Files uploaded successfully');
      setPendingFiles([]);
      setListFiles([...listFiles, ...createdItems]);
      setIsOpen(false);
    } catch {
      // apiClient's error interceptor already shows a toast
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <ModalComponent isOpen={isOpen} setIsOpen={setIsOpen} onAfterClose={() => setPendingFiles([])}>
      <div className='p-4'>
        <h3 className='title-h5-m-bold mb-3'>Upload a new file</h3>

        <div className='pt-4 pb-3'>
          <UploadHubFileDropzone pendingFiles={pendingFiles} setPendingFiles={setPendingFiles} />
        </div>

        <div className='d-flex justify-content-end pb-3 py-1'>
          <button
            className='general-button action-button rounded-pill px-4'
            disabled={pendingFiles.length === 0 || isUploading}
            onClick={handleUpload}
          >
            {isUploading && <i className='fas fa-spinner fa-spin d-inline-block-centered mr-2' />}
            Upload files
          </button>
        </div>
      </div>
    </ModalComponent>
  );
};

export default UploadHubModalAdd;
